"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var utilities_1 = require("@dynamynd/utilities");

var react_1 = __importDefault(require("react"));

var styled_components_1 = require("styled-components");

var styled_1 = require("../styled");

var styled_2 = require("./styled");

var Footer = function Footer(props) {
  var privacyAction = props.privacyAction,
      termsAction = props.termsAction,
      contactUsAction = props.contactUsAction,
      theme = props.theme;
  var currentYear = utilities_1.getCurrentYear();
  return react_1.default.createElement(responsive_1.ResponsiveContext.Consumer, null, function (_a) {
    var activeBreakpoint = _a.activeBreakpoint;
    return react_1.default.createElement(styled_2.FooterContainer, {
      activeBreakpoint: activeBreakpoint
    }, react_1.default.createElement(styled_2.FooterWrapper, {
      activeBreakpoint: activeBreakpoint
    }, react_1.default.createElement(styled_2.AllRightsReservedLabel, {
      color: theme.colors.title
    }, "\xA9Kathy Kolbe 1987-", currentYear, ". All Rights Reserved."), react_1.default.createElement(styled_2.LinksContainer, {
      activeBreakpoint: activeBreakpoint
    }, react_1.default.createElement(styled_1.TextLink, {
      onPress: privacyAction,
      "aria-label": "Privacy Policy"
    }, "Privacy"), react_1.default.createElement(styled_1.TextLink, {
      onPress: termsAction,
      "aria-label": "Terms and Conditions"
    }, "Terms & Conditions"), react_1.default.createElement(styled_1.TextLink, {
      onPress: contactUsAction,
      "aria-label": "Contact us"
    }, "Contact Us"))));
  });
};

exports.default = styled_components_1.withTheme(Footer);